import * as React from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import diyLightTheme = require('diy/material-ui/diyLightTheme');
import SyncPosition, {PositionBox} from "diy/components/SyncPosition";
import Modul from 'diy/module/Modul';
import GroupOverlay from './GroupOverlay';
import {BackgroundSettings} from '../state';
import {ConfigurableGroups} from '../../sectionContainer/index';
import {trackBackgroundColorClicked, trackBackgroundTabClicked, trackManageGroupBackgroundClicked} from "../tracking";
export interface StateProps {
    backgroundSettings: {
        [groupId: string]: BackgroundSettings
    };
    backgroundMenuOpen: {
        [groupId: string]: boolean;
    };
    configurableGroups: ConfigurableGroups;
    showDeleteButton: boolean;
    visibleOverlays: number[];
    rootSectionId: number;
}

export interface DispatchProps {
    onChangeBackgroundImage?(
        moduleId: number,
        imageId: number,
        imageType: string,
        successCallback: () => void,
        errorCallback: () => void
    ): void;
    onChangeBackground?(moduleId: number, background: BackgroundSettings): void;
    onDeleteGroup(moduleId: number): void;
    onClickOutside(): void;
    onEditImageClicked(groupId: number): void;
    onSelectImageClicked(groupId: number): void;
    onBackgroundMenuOpened(groupId: number): void;
    onBackgroundMenuClosed(groupId: number): void;
    onSyncGroupsBackground(moduleId: number): void;
}

export interface GroupOverlaysProps extends React.Props<GroupOverlays>, StateProps, DispatchProps {
}

export default class GroupOverlays extends React.Component<GroupOverlaysProps, {}> {
    renderRootSubOverlay() {
        if (!this.props.rootSectionId) {
            return null;
        }

        let module = Modul.getInstance(this.props.rootSectionId);

        if (!module) {
            return null;
        }

        return this.props.rootSectionId > 0 ?
            <SyncPosition
                element={module.modul[0]}
                key="rootGroupOverlay"
                position="absolute"
            >
                {
                    (box: PositionBox) => (
                        <div
                            onClick={this.props.onClickOutside}
                            style={{
                                position: "absolute",
                                zIndex: GroupOverlay.ZINDEX,
                                left: box.left,
                                top: box.top,
                                width: box.width,
                                height: box.height,
                                boxSizing: 'border-box'
                            }}
                        ></div>
                    )
                }
            </SyncPosition> : null;
    }

    render() {
        let overlaysToRender = this.props.visibleOverlays &&
            Object.keys(this.props.visibleOverlays).length &&
            this.props.backgroundSettings;

        return (
            <MuiThemeProvider muiTheme={diyLightTheme}>
            <div>
                {overlaysToRender ? this.renderRootSubOverlay() : null}
                {overlaysToRender ?
                    this.props.visibleOverlays.map(groupId => {
                        let changeBackgroundImageHandler = this.createChangeBgImgHandler(groupId);
                        let changeBackgroundHandler = this.createChangeBgHandler(groupId);

                        return <GroupOverlay
                            moduleId={groupId}
                            key={groupId}
                            configurableGroup={this.props.configurableGroups[groupId]}
                            backgroundSettings={this.props.backgroundSettings[groupId]}
                            backgroundMenuOpen={this.props.backgroundMenuOpen && this.props.backgroundMenuOpen[groupId]}
                            onChangeBackgroundImage={changeBackgroundImageHandler}
                            onChangeBackground={changeBackgroundHandler}
                            onColorClicked={trackBackgroundColorClicked}
                            onEditImageClicked={() => this.props.onEditImageClicked(groupId)}
                            onSelectImageClicked={() => this.props.onSelectImageClicked(groupId)}
                            onManageGroupBackgroundOpened={() => this.onBackgroundMenuOpened(groupId)}
                            onManageGroupBackgroundClosed={() => this.props.onBackgroundMenuClosed(groupId)}
                            onTabClicked={trackBackgroundTabClicked}
                            onDelete={this.props.onDeleteGroup}
                            showDeleteButton={this.props.showDeleteButton}
                            onApplyOnAllGroups={this.props.onSyncGroupsBackground}
                        />;
                    }) : null
                }
            </div>
            </MuiThemeProvider>
        );
    }

    private onBackgroundMenuOpened = (groupId: number) => {
        trackManageGroupBackgroundClicked();
        this.props.onBackgroundMenuOpened(groupId);
    }

    private createChangeBgImgHandler = (moduleId: number) => (
        imageId: number,
        imageType: string,
        successCallback: () => void,
        errorCallback: () => void
    ) => {
        this.props.onChangeBackgroundImage(
            moduleId, imageId, imageType, successCallback, errorCallback
        );
    };

    private createChangeBgHandler = (moduleId: number) => (
        background: BackgroundSettings
    ) => {
        this.props.onChangeBackground(moduleId, background);
    };
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/section/components/GroupOverlays.tsx
 **/